module.exports = __webpack_public_path__ + "img/logo-wip.5af7c523.svg";